<script>
export default {
  name: 'IconCipherDollarCircle',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#C5A32E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 15.9201H13.4C14.05 15.9201 14.59 15.3401 14.59 14.6401C14.59 13.7701 14.28 13.6001 13.77 13.4201L12.76 13.0701V15.9201H12.75Z"
      :fill="color"
    />
    <path
      d="M11.9701 1.89992C6.45007 1.91992 1.98007 6.40992 2.00007 11.9299C2.02007 17.4499 6.51007 21.9199 12.0301 21.8999C17.5501 21.8799 22.0201 17.3899 22.0001 11.8699C21.9801 6.34992 17.4901 1.88992 11.9701 1.89992ZM14.2601 11.9999C15.0401 12.2699 16.0901 12.8499 16.0901 14.6399C16.0901 16.1799 14.8801 17.4199 13.4001 17.4199H12.7501V17.9999C12.7501 18.4099 12.4101 18.7499 12.0001 18.7499C11.5901 18.7499 11.2501 18.4099 11.2501 17.9999V17.4199H10.8901C9.25007 17.4199 7.92007 16.0399 7.92007 14.3399C7.92007 13.9299 8.26007 13.5899 8.67007 13.5899C9.08007 13.5899 9.42007 13.9299 9.42007 14.3399C9.42007 15.2099 10.0801 15.9199 10.8901 15.9199H11.2501V12.5399L9.74007 11.9999C8.96007 11.7299 7.91007 11.1499 7.91007 9.35992C7.91007 7.81992 9.12007 6.57992 10.6001 6.57992H11.2501V5.99992C11.2501 5.58992 11.5901 5.24992 12.0001 5.24992C12.4101 5.24992 12.7501 5.58992 12.7501 5.99992V6.57992H13.1101C14.7501 6.57992 16.0801 7.95992 16.0801 9.65992C16.0801 10.0699 15.7401 10.4099 15.3301 10.4099C14.9201 10.4099 14.5801 10.0699 14.5801 9.65992C14.5801 8.78992 13.9201 8.07992 13.1101 8.07992H12.7501V11.4599L14.2601 11.9999Z"
      :fill="color"
    />
    <path
      d="M9.41992 9.37008C9.41992 10.2401 9.72992 10.4101 10.2399 10.5901L11.2499 10.9401V8.08008H10.5999C9.94992 8.08008 9.41992 8.66008 9.41992 9.37008Z"
      :fill="color"
    />
  </svg>
</template>
